/** Quilted CodeSystem for the service mutation a Provenance records. */
export const CHARGE_ITEM_PROVENANCE_ACTIVITY_SYSTEM =
  "http://quiltedhealth.com/fhir/CodeSystem/charge-item-provenance-activity";

/**
 * The ChargeItem mutations that produce a service history entry.
 *
 * Scoped to the changes Version History reports: create, field edits (including fee type),
 * billed/unbilled, and archive/unarchive.
 */
export enum ChargeItemProvenanceActivityCode {
  Created = "created",
  Edited = "edited",
  StatusChanged = "status-changed",
  ArchivedChanged = "archive-toggled",
}

export const CHARGE_ITEM_PROVENANCE_ACTIVITY_DISPLAY: Record<
  ChargeItemProvenanceActivityCode,
  string
> = {
  [ChargeItemProvenanceActivityCode.Created]: "Service created",
  [ChargeItemProvenanceActivityCode.Edited]: "Service edited",
  [ChargeItemProvenanceActivityCode.StatusChanged]: "Service status changed",
  [ChargeItemProvenanceActivityCode.ArchivedChanged]: "Service archive changed",
};
